import "material-icons/iconfont/material-icons.css";
import { useState, useEffect } from "react";
import { usePathname } from "components/Navigation";
import ApplicationMenu from "./ApplicationMenu";
import Link from "components/Link";
import SidebarRisiko from "pages/(app)/SidebarRisiko";
import SidebarRisikoDetail from "pages/(app)/SidebarRisikoDetail";
import { FaWhatsapp, FaLightbulb } from "react-icons/fa6";
import TooltipsApp from "./TooltipsApp";

export const LAYOUT_RISIKO_VAR_ARR = [
  "risk_profile",
  "risk_capacity_limit",
  "risk_sasaran",
  "risk_metrik_strategi_risiko",
  "risk_profile_analisa_risiko_inheren",
  "risk_profile_analisa_risiko_residual",
  "risk_profile_rencana_perlakuan_risiko",
  "risk_profile_realisasi_risiko_residual",
  "risk_profile_real_risiko",
  "risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya",
  "risk_ikhtisar",
  "lost_event",
  // "internal_control_testing",
  "risk_history",
  "testing_risk_profile_new",
];

const LAYOUT_DETAIL_RISIKO_VAR_ARR = [
  "detail_risk_profile",
  // "risk_capacity_limit",
  // "risk_sasaran",
  // "risk_metrik_strategi_risiko",
  "detail_risk_profile_analisa_risiko_inheren",
  "detail_risk_profile_analisa_risiko_residual",
  "detail_risk_profile_rencana_perlakuan_risiko",
  "detail_risk_profile_realisasi_risiko_residual",
  "detail_risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya",
];

const Sidebar = (props) => {
  const pathname = usePathname();
  const [isLayoutRisiko, setisLayoutRisiko] = useState(false);
  const [is_detail, setis_detail] = useState(false);

  useEffect(() => {
    // // console.log('props=>')
    // // console.log(pathname)

    handleInitLyt();
  }, [pathname]);

  const handleInitLyt = () => {
    const lyt_risiko = LAYOUT_RISIKO_VAR_ARR;
    const lyt_detail_risiko = LAYOUT_DETAIL_RISIKO_VAR_ARR;

    const pathname_arr = pathname.split("/");
    // // console.log('pathname_arr')
    // // console.log(pathname_arr)
    let isLayoutRisiko = false;
    for (let i = 0; i < pathname_arr.length; i++) {
      for (let x = 0; x < lyt_risiko.length; x++) {
        if (lyt_risiko[x] == pathname_arr[i]) {
          isLayoutRisiko = true;
          break;
        }
      }
      if (isLayoutRisiko === true) {
        break;
      }
    }
    setisLayoutRisiko(isLayoutRisiko);

    if (isLayoutRisiko) {
      setisLayoutRisiko(isLayoutRisiko);
      return;
    }

    // let is_detail = false
    // for (let i = 0; i < pathname_arr.length; i++) {
    //     for (let x = 0; x < lyt_detail_risiko.length; x++) {
    //         if (lyt_detail_risiko[x] == pathname_arr[i]) {
    //             is_detail = true
    //             break;
    //         }
    //     }
    //     if (is_detail === true) {
    //         break
    //     }
    // }

    // if (is_detail) {
    //     setisLayoutRisiko(true)
    //     setis_detail(true)
    // } else {
    //     setisLayoutRisiko(false)
    //     setis_detail(false)

    // }
  };

  return (
    <div
      // style={{ backgroundImage: `url('/sidebar.png')` }}
      className={`container-sidebar position-sticky ${
        isLayoutRisiko ? "bg-white" : ""
      }`}
    >
      {/* <SidebarRisiko /> */}
      {isLayoutRisiko ? (
        <>{!is_detail ? <SidebarRisiko /> : <SidebarRisikoDetail />}</>
      ) : (
        <ApplicationMenu />
      )}

      <div style={{ height: 70 }}></div>
      {/* <div className="c-icon-chat-container">
        <TooltipsApp
          title={"Masukan & Pertanyaan"}
          id={"bantuan"}
          placement={"top"}
          children={
            <a
              href="https://wa.me/6285187287384/?text=Hai, saya mau tanya tentang *ManRisk*%2C"
              className="circle-button green"
            >
              <FaWhatsapp size={24} color="white" />
            </a>
          }
        />

        <TooltipsApp
          title={"Request Fitur"}
          id={"kontak-darurat"}
          placement={"top"}
          children={
            <a href="/reques_fitur" className="circle-button yellow">
              <FaLightbulb size={24} color="white" />
            </a>
          }
        />
      </div> */}
    </div>
  );
};

export default Sidebar;
